import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class V4Service {
  TOKEN = localStorage.getItem('token');

  constructor(private http: HttpClient) {}

  private authHeaders(): HttpHeaders {
    this.TOKEN = localStorage.getItem('token');
    return new HttpHeaders({ 'content-Type': 'application/json', Authorization: this.TOKEN || '' });
  }

  private buildParams(params?: any): HttpParams {
    let httpParams = new HttpParams();
    if (!params) {
      return httpParams;
    }
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }

  // Familias
  getFamilias(): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + '/api/familias/', { headers });
  }

  crearFamilia(data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      fd.append('nombre', data.nombre || '');
      fd.append('descripcion', data.descripcion || '');
      fd.append('activo', String(data.activo === undefined ? '1' : data.activo));
      if (data.imagen) {
        fd.append('imagen', data.imagen);
      }
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.post<any[]>(environment.BASE_URL + '/api/familias/', body, { headers });
  }

  actualizarFamilia(id: number, data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      if (data.nombre !== undefined) {
        fd.append('nombre', data.nombre);
      }
      if (data.descripcion !== undefined) {
        fd.append('descripcion', data.descripcion || '');
      }
      if (data.activo !== undefined) {
        fd.append('activo', String(data.activo));
      }
      if (data.imagen) {
        fd.append('imagen', data.imagen);
      }
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.put<any[]>(environment.BASE_URL + `/api/familias/${id}/`, body, { headers });
  }

  eliminarFamilia(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/familias/${id}/`, { headers });
  }

  getFamiliaGrupos(familiaId: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + `/api/familia-grupos-v2/?familia=${familiaId}`, { headers });
  }

  getFamiliaGruposPorGrupo(grupoId: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + `/api/familia-grupos-v2/?grupo=${grupoId}`, { headers });
  }

  crearFamiliaGrupo(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/familia-grupos-v2/', data, { headers });
  }

  eliminarFamiliaGrupo(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/familia-grupos-v2/${id}/`, { headers });
  }

  configurarFamiliaGrupos(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/familia-grupos-v2/configurar/', data, { headers });
  }

  // Paquetes v2
  getPaquetes(): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + '/api/paquetes-v2/', { headers });
  }

  crearPaquete(data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      fd.append('nombre', data.nombre || '');
      fd.append('descripcion', data.descripcion || '');
      fd.append('precio', data.precio || '');
      if (data.familia) {
        fd.append('familia', data.familia);
      }
      fd.append('activo', String(data.activo === undefined ? '1' : data.activo));
      if (data.imagen) {
        fd.append('imagen', data.imagen);
      }
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.post<any[]>(environment.BASE_URL + '/api/paquetes-v2/', body, { headers });
  }

  actualizarPaquete(id: number, data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      if (data.nombre !== undefined) {
        fd.append('nombre', data.nombre);
      }
      if (data.descripcion !== undefined) {
        fd.append('descripcion', data.descripcion || '');
      }
      if (data.precio !== undefined) {
        fd.append('precio', data.precio || '');
      }
      if (data.familia) {
        fd.append('familia', data.familia);
      }
      if (data.activo !== undefined) {
        fd.append('activo', String(data.activo));
      }
      if (data.imagen) {
        fd.append('imagen', data.imagen);
      }
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.put<any[]>(environment.BASE_URL + `/api/paquetes-v2/${id}/`, body, { headers });
  }

  eliminarPaquete(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/paquetes-v2/${id}/`, { headers });
  }

  // Tipos compartidos por productos y variaciones v2
  getTiposProducto(params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + '/api/tipos-producto-v2/', { headers, params: this.buildParams(params) });
  }

  crearTipoProducto(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/tipos-producto-v2/', data, { headers });
  }

  actualizarTipoProducto(id: number, data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.put<any[]>(environment.BASE_URL + `/api/tipos-producto-v2/${id}/`, data, { headers });
  }

  eliminarTipoProducto(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/tipos-producto-v2/${id}/`, { headers });
  }

  // Productos v2
  getProductos(params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + '/api/productos-v2/', { headers, params: this.buildParams(params) });
  }

  crearProducto(data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      fd.append('nombre', data.nombre || '');
      fd.append('tipo', data.tipo || '');
      fd.append('descripcion', data.descripcion || '');
      fd.append('activo', String(data.activo === undefined ? '1' : data.activo));
      if (data.imagen) {
        fd.append('imagen', data.imagen);
      }
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.post<any[]>(environment.BASE_URL + '/api/productos-v2/', body, { headers });
  }

  actualizarProducto(id: number, data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      if (data.nombre !== undefined) {
        fd.append('nombre', data.nombre);
      }
      if (data.tipo !== undefined) {
        fd.append('tipo', data.tipo || '');
      }
      if (data.descripcion !== undefined) {
        fd.append('descripcion', data.descripcion || '');
      }
      if (data.activo !== undefined) {
        fd.append('activo', String(data.activo));
      }
      if (data.imagen) {
        fd.append('imagen', data.imagen);
      }
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.put<any[]>(environment.BASE_URL + `/api/productos-v2/${id}/`, body, { headers });
  }

  eliminarProducto(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/productos-v2/${id}/`, { headers });
  }

  getProductoImagenes(productoId: number, params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(
      environment.BASE_URL + `/api/producto-imagenes-v2/?producto=${productoId}`,
      { headers, params: this.buildParams(params) }
    );
  }

  crearProductoImagen(data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      Object.keys(data).forEach((k) => {
        if (data[k] !== undefined && data[k] !== null) {
          fd.append(k, data[k]);
        }
      });
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.post<any[]>(environment.BASE_URL + '/api/producto-imagenes-v2/', body, { headers });
  }

  actualizarProductoImagen(id: number, data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      Object.keys(data).forEach((k) => {
        if (data[k] !== undefined && data[k] !== null) {
          fd.append(k, data[k]);
        }
      });
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.put<any[]>(environment.BASE_URL + `/api/producto-imagenes-v2/${id}/`, body, { headers });
  }

  eliminarProductoImagen(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/producto-imagenes-v2/${id}/`, { headers });
  }

  // Fotos de configuraciones v2
  getConfiguracionImagenes(configuracionId: number, params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(
      environment.BASE_URL + `/api/variacion-config-imagenes-v2/?configuracion=${configuracionId}`,
      { headers, params: this.buildParams(params) }
    );
  }

  crearConfiguracionImagen(data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      Object.keys(data).forEach((k) => {
        if (data[k] !== undefined && data[k] !== null) {
          fd.append(k, data[k]);
        }
      });
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.post<any[]>(environment.BASE_URL + '/api/variacion-config-imagenes-v2/', body, { headers });
  }

  actualizarConfiguracionImagen(id: number, data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      Object.keys(data).forEach((k) => {
        if (data[k] !== undefined && data[k] !== null) {
          fd.append(k, data[k]);
        }
      });
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.put<any[]>(environment.BASE_URL + `/api/variacion-config-imagenes-v2/${id}/`, body, { headers });
  }

  eliminarConfiguracionImagen(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/variacion-config-imagenes-v2/${id}/`, { headers });
  }

  // Variaciones v2
  getVariaciones(productoId?: number, params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    const query = { ...(params || {}) };
    if (productoId) {
      query.producto = productoId;
    }
    return this.http.get<any[]>(environment.BASE_URL + '/api/producto-variaciones-v2/', { headers, params: this.buildParams(query) });
  }

  crearVariacion(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/producto-variaciones-v2/', data, { headers });
  }

  actualizarVariacion(id: number, data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.put<any[]>(environment.BASE_URL + `/api/producto-variaciones-v2/${id}/`, data, { headers });
  }

  eliminarVariacion(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/producto-variaciones-v2/${id}/`, { headers });
  }

  // Variaciones base v2
  getVariacionesBase(params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL + '/api/variaciones-v2/', { headers, params: this.buildParams(params) });
  }

  crearVariacionBase(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/variaciones-v2/', data, { headers });
  }

  actualizarVariacionBase(id: number, data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.put<any[]>(environment.BASE_URL + `/api/variaciones-v2/${id}/`, data, { headers });
  }

  eliminarVariacionBase(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/variaciones-v2/${id}/`, { headers });
  }

  // Configuraciones de variación v2
  getConfiguraciones(variacionId?: number, params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    const query = { ...(params || {}) };
    if (variacionId) {
      query.variacion = variacionId;
    }
    return this.http.get<any[]>(environment.BASE_URL + '/api/producto-variacion-configs-v2/', { headers, params: this.buildParams(query) });
  }

  crearConfiguracion(data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      Object.keys(data).forEach((k) => {
        if (data[k] !== undefined && data[k] !== null) {
          fd.append(k, data[k]);
        }
      });
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.post<any[]>(environment.BASE_URL + '/api/producto-variacion-configs-v2/', body, { headers });
  }

  actualizarConfiguracion(id: number, data: any): Observable<any[]> {
    let headers = this.authHeaders();
    let body: any = data;
    if (!(data instanceof FormData)) {
      const fd = new FormData();
      Object.keys(data).forEach((k) => {
        if (data[k] !== undefined && data[k] !== null) {
          fd.append(k, data[k]);
        }
      });
      body = fd;
      headers = headers.delete('content-Type');
    }
    return this.http.put<any[]>(environment.BASE_URL + `/api/producto-variacion-configs-v2/${id}/`, body, { headers });
  }

  eliminarConfiguracion(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/producto-variacion-configs-v2/${id}/`, { headers });
  }

  // Configuraciones permitidas por producto v2
  getProductoConfiguraciones(productoId: number, params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    const query = { ...(params || {}), producto: productoId };
    return this.http.get<any[]>(environment.BASE_URL + '/api/producto-configuraciones-v2/', { headers, params: this.buildParams(query) });
  }

  crearProductoConfiguracion(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/producto-configuraciones-v2/', data, { headers });
  }

  actualizarProductoConfiguracion(id: number, data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.put<any[]>(environment.BASE_URL + `/api/producto-configuraciones-v2/${id}/`, data, { headers });
  }

  eliminarProductoConfiguracion(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/producto-configuraciones-v2/${id}/`, { headers });
  }

  // Paquete-Producto v2
  getPaqueteProductos(paqueteId: number, params?: any): Observable<any[]> {
    const headers = this.authHeaders();
    const query = { ...(params || {}), paquete: paqueteId };
    return this.http.get<any[]>(environment.BASE_URL + '/api/paquete-productos-v2/', { headers, params: this.buildParams(query) });
  }

  agregarPaqueteProducto(data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL + '/api/paquete-productos-v2/', data, { headers });
  }

  actualizarPaqueteProducto(id: number, data: any): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.put<any[]>(environment.BASE_URL + `/api/paquete-productos-v2/${id}/`, data, { headers });
  }

  eliminarPaqueteProducto(id: number): Observable<any[]> {
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL + `/api/paquete-productos-v2/${id}/`, { headers });
  }
}
